import { render, staticRenderFns } from "./preLive.vue?vue&type=template&id=5b91fff4&scoped=true&"
import script from "./preLive.vue?vue&type=script&lang=js&"
export * from "./preLive.vue?vue&type=script&lang=js&"
import style0 from "./preLive.vue?vue&type=style&index=0&id=5b91fff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91fff4",
  null
  
)

export default component.exports